export default {
  Onhand: 'onhand',
  Onhand2: 'onhand2',
}
